export const BusinessMandatoryOnboardingStepsArr = [1, 2, 3, 4]
export const AllBusinessOnboardingStepsArr = [1, 2, 3, 4]
export const UserTypeLabels = { BUSINESS: 1, FREELANCER: 2, INTERN: 3, BUSINESS_MANAGER: 4, BUSINESS_EMPLOYEE: 5 };
export const FreelancerProfileSections = { PERSONAL: "personal", PROFESSIONAL: "professional", PAYMENT: "payment" }